<template>
	<div v-if="isSearched && pages.total == 0 && images.total == 0" class="row mx-3">
		<p class="text-muted">{{ __('translations.message.no_result_found') }}</p>
    </div>
	<div v-else-if="isSearched" class="container-fluid">
		<div class="row justify-content-center">
			<div class="col-12">
				<ul class="nav nav-tabs mx-4 mt-3" role="tablist" id="search-result-tabs">
	              <li v-if="pages.total > 0" class="nav-item">
	                <a class="nav-link" :class="{'active' : activeTab === 'pages-tab'}" @click="activeTab = 'pages-tab'" id="pages-tab" data-toggle="tab" href="#pages" role="tab" aria-controls="pages">{{__('translations.notebooks')}}<span>&nbsp;({{pages.total}})</span></a>
	              </li>
	              <li v-if="images.total > 0" class="nav-item">
	                <a class="nav-link" :class="{'active' : activeTab === 'images-tab'}" @click="activeTab = 'images-tab'" id="images-tab" data-toggle="tab" href="#images" role="tab" aria-controls="images">{{ __('translations.title.images') }}<span>&nbsp;({{images.total}})</span></a>
	              </li>
	            </ul>
	        </div>
	    </div>
		<div class="tab-content px-2">
	        <div v-if="pages.total > 0" class="tab-pane fade" :class="{'show active' : activeTab === 'pages-tab'}" id="pages" role="tabpanel" aria-labelledby="pages-tab">
	    		<pages v-if="!isPageLoading" :display-header="false" :display-not-found-message="true"></pages>
				
				<div v-if="isPageLoading" class="row mt-5 mx-0">
			    	<div class="col text-center">
				    	<div class="spinner-border" role="status" style="color: #ccc">
							<span class="sr-only">Loading...</span>
						</div>
					</div>
			    </div>
			    
				<div v-if="pages.last_page > 1" class="row my-5">
    				<div class="col text-center">
    					<button :disabled="pages.current_page <= 1" class="btn btn-primary mr-2" @click="loadPages(1)"><i class="fas fa-angle-double-left" style="vertical-align: middle;"></i></button>
    					<button :disabled="pages.current_page <= 1" class="btn btn-primary mr-2" @click="loadPages(parseInt(pages.current_page) - 1)"><i class="fas fa-angle-left" style="vertical-align: middle;"></i></button>
    					<div class="d-inline-block" style="color: #3f5864">
    						Page <input type="text" v-model="pages.current_page" @keyup.enter="loadPages(pages.current_page)" class="form-control d-inline-block mx-2" style="width: 50px" /> sur {{pages.last_page}}
   						</div>
    					<button :disabled="pages.current_page >= pages.last_page" class="btn btn-primary ml-2" @click="loadPages(parseInt(pages.current_page) + 1)"><i class="fas fa-angle-right" style="vertical-align: middle;"></i></button>
    					<button :disabled="pages.current_page >= pages.last_page" class="btn btn-primary ml-2" @click="loadPages(pages.last_page)"><i class="fas fa-angle-double-right" style="vertical-align: middle;"></i></button>
   					</div>
				</div>
	    	</div>
	    	
	    	<div v-if="images.total > 0" class="tab-pane fade" :class="{'show active' : activeTab === 'images-tab'}" id="images" role="tabpanel" aria-labelledby="images-tab">
	        	<images v-if="!isImageLoading" :display-header="false" :display-not-found-message="true"></images>
	        	
	        	<div v-if="isImageLoading" class="row mt-5 mx-0">
			    	<div class="col text-center">
				    	<div class="spinner-border" role="status" style="color: #ccc">
							<span class="sr-only">Loading...</span>
						</div>
					</div>
			    </div>
			    
        		<div v-if="images.last_page > 1" class="row my-5">
    				<div class="col text-center">
    					<button :disabled="images.current_page <= 1" class="btn btn-primary mr-2" @click="loadImages(1)"><i class="fas fa-angle-double-left" style="vertical-align: middle;"></i></button>
    					<button :disabled="images.current_page <= 1" class="btn btn-primary mr-2" @click="loadImages(parseInt(images.current_page) - 1)"><i class="fas fa-angle-left" style="vertical-align: middle;"></i></button>
    					<div class="d-inline-block" style="color: #3f5864">
    						Page <input type="text" v-model="images.current_page" @keyup.enter="loadImages(images.current_page)" class="form-control d-inline-block mx-2" style="width: 50px" /> sur {{images.last_page}}
   						</div>
    					<button :disabled="images.current_page >= images.last_page" class="btn btn-primary ml-2" @click="loadImages(parseInt(images.current_page) + 1)"><i class="fas fa-angle-right" style="vertical-align: middle;"></i></button>
    					<button :disabled="images.current_page >= images.last_page" class="btn btn-primary ml-2" @click="loadImages(images.last_page)"><i class="fas fa-angle-double-right" style="vertical-align: middle;"></i></button>
   					</div>
				</div>
	        </div>
	    </div>
	</div>
	<div v-else-if="isSearching" class="row mt-5 mx-0">
    	<div class="col text-center">
	    	<div class="spinner-border" role="status" style="color: #ccc">
				<span class="sr-only">Loading...</span>
			</div>
		</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
var moment = require('moment');

export default {
    name: 'SearchResult',
    data() {
        return {
            activeTab: 'pages-tab',
            isImageLoading: false,
            isPageLoading: false,
        }
    },
    watch: {
    	isSearched(value) {
    		if(value) {
    			if(this.activeTab == 'images-tab' && this.images.total == 0) {
    				this.activeTab = 'pages-tab';
    			} else if (this.activeTab == 'pages-tab' && this.pages.total == 0) {
    				this.activeTab = 'images-tab';
    			}
    		}
    	}
    },
    computed: {
		...mapGetters([
			'images', 'pages', 'isSearching', 'isSearched'
		]),
    },
    methods: {
    	loadImages(pageNum) {
    		this.images.current_page = pageNum;
    		this.isImageLoading = true;
    		
    		var params = this.$store.state.searchParams;
    		params.page = pageNum;
    		
    		this.$store.commit('SET_SEARCH_PARAMS', params);
    		this.$store.dispatch('IMAGE_SEARCH').then((response) => {
    			this.isImageLoading = false;
    		});
    	},
    	loadPages(pageNum) {
    		this.pages.current_page = pageNum;
    		this.isPageLoading = true;
    		
    		var params = this.$store.state.searchParams;
    		params.page = pageNum;
    		
    		this.$store.commit('SET_SEARCH_PARAMS', params);
    		this.$store.dispatch('PAGE_SEARCH').then((response) => {
    			this.isPageLoading = false;
    		});
    	}
	}
}
</script>